<template>
<!-- NOTE (TEMPLATE) error page 403 "you are not allowed to view this page" -->

 
  <div class="app flex-row align-items-center Back ">
    <!-- NOTE (TEMPLATE) error page 403 "you are not allowed to view this page" -->

    <div class="container">
      <b-row class="justify-content-center ">
        <div class="col">
          <!-- <div style=" height: 20vh"></div> -->
          <div>
            <b-jumbotron>
              <template v-slot:header
                ><span class="text-secondary display-3">در حال توسعه</span></template>

              <template v-slot:lead>
                <h2 class="text-info">این بخش در حال تولید است و به زودی در اختیار شما قرار خواهد گرفت!</h2>
              </template>

              <hr />

              <b-button variant="success" @click="goback()">خانه</b-button>
            </b-jumbotron>
          </div>
        </div>
        <!-- <p style="font-size:100px" class="text-primary">404 </p> -->

        <div class="col">
          <img src="../assets/images/comingSoon.gif" class="container-fluid" />
        </div>

        <!-- 
        <b-col >
           <div class="clearfix">
            <h1 class="float-left display-3 mr-4">
            404
            </h1>
            <h4 class="pt-3">برگه یافت نشد</h4>
         
            <a href="/">
              <p class="text-muted">بازگشت به خانه</p>
            </a>
          </div>
            
        </b-col>
        <b-col class="6">
          
        </b-col>
       -->
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",

  methods: {
    goback() {
      // this.$router.go(-2);
      this.$router.push('/')
    }
  }
};
</script>
<style>
.Back {
  background-color: #ffffff;
  /* background-image: url("../assets/images/resBack.png");

  background-size: cover; */
}
.jumbotron {
  background-color: #ffffff;
}
/* .responsive {
  width: 100%;
  max-width: 800px;
  height: auto;
} */
</style>
